import { OrderErrorCode } from "@saleor/createOrChangeNotRefContract/views/createOrChangeNotRefContractView/const";

function getErrorOutDated(errorData) {
  const errorOutDated = errorData?.errors?.find(
    e => e.code.toLowerCase() === OrderErrorCode.outDated
  );
  let responseData = null;
  if (errorData?.errors?.length > 0 && errorOutDated) {
    responseData = {
      ...errorData,
      errorOutDated
    };
  }
  return responseData;
}

export default getErrorOutDated;
